module.exports = __webpack_public_path__ + "images/eq-blue-playing.59495660cb63cf657ff324021a7c7fc7.gif";